import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';
export class ResultQueryInfo{
  ResultQuerySubjectList: ResultQuerySubjectList[];
  ResultQueryApplicationID:number;
  StudentID:number;
  ExamInstanceID:number;
  CoursePartID:number;
  BranchID:number;
  ResultQueryStatus:string;
  ResultQueryDate:string;
  CreatedLoginID:number;
  UpdatedLoginID:number

}

export class ResultQuerySubjectList 
	{
		ApplicationSubjectID:number
		ApplicationID:number;
	  SubjectID:number;
	  ApplicationIN:string;
	  ApplicationINDate:string;
	  ApplicationReady:string;
	  ApplicationReadyDate:string;
	  ApplicationOut:string;
	  ApplicationOutDate:string;
	  DeleteFlag:string;
	  CreatedLoginID:number;
	  UpdatedLoginID:number;
    ApplicationDate:string;
    ApplicationFees:string;
    ApplicationDDNO:number;
    ApplicationDDDate:string;
    ResultQueryTypeID:number;
    ApplicationNo:number;

	}
@Injectable({
  providedIn: 'root'
})

export class PhotocopyService {
  constructor(private dataService: DataAccessService) {
  }
  public GetPreStudentInstanceInfoForResultQuery(StudentID,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQueryInfo/';
    this.dataService.setMethodName = 'GetPreStudentInstanceInfoForResultQuery?StudentID='+ StudentID +'&ExamInstanceID='+ExamInstanceID; 
    return this.dataService.getAll<ResultQueryInfo[]>()
  }
  public GetResultQuerySchedule(ExamInstanceID,ResultQueryTypeID,CourseID,ResultDate) {debugger
    this.dataService.setControllerName = '/ResultQueryInfo/';
    this.dataService.setMethodName = 'GetResultQuerySchedule?ExamInstanceID='+ExamInstanceID+'&ResultQueryTypeID='+ResultQueryTypeID+'&CourseID='+CourseID+'&ResultDate='+ResultDate; 
    return this.dataService.getAll<ResultQueryInfo[]>()
  }
  public GetDataForPortalPhotocopyApplication(StudentID,ExamInstanceID,CoursePartID,ResultQueryTypeID,RevalApplyDays,ResultQueryID,ApplicationNO,ResultQueryPhotocopy) {debugger
    this.dataService.setControllerName = '/ResultQueryInfo/';
    this.dataService.setMethodName = 'GetDataForPortalPhotocopyApplication?StudentID='+ StudentID +'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID+'&ResultQueryTypeID='+ResultQueryTypeID+'&RevalApplyDays='+RevalApplyDays+'&ResultQueryID='+ResultQueryID+'&ApplicationNO='+ApplicationNO+'&ResultQueryPhotocopy='+ResultQueryPhotocopy;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public GetPortalApplicationData(StudentID,CoursePartID,BranchID,ResultQueryTypeID,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQueryInfo/';
    this.dataService.setMethodName = 'GetPortalApplicationData?StudentID='+ StudentID+'&CoursePartID='+CoursePartID +'&BranchID='+BranchID+'&ResultQueryTypeID='+ResultQueryTypeID+'&ExamInstanceID='+ExamInstanceID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public save(data) {debugger
    this.dataService.setControllerName = '/ResultQueryInfo/';
    this.dataService.setMethodName = 'PostInsertResultQueryInfo'; // setting method name from API controller.
    return this.dataService.add<ResultQueryInfo>(data)
  }

  public GetUpdatePaymentStatusForResultQuerySubject(ResultQueryTypeID,merchantTxnNo,ExamInstanceID,ApplicationNO) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetUpdatePaymentStatusForResultQuerySubject?ResultQueryTypeID='+ResultQueryTypeID+'&merchantTxnNo='+ merchantTxnNo + '&ExamInstanceID='+ExamInstanceID+'&ApplicationNO='+ApplicationNO; // setting method name from API controller.
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public GetRevaluationDashboardData(StudentID,CoursePartID,ResultQueryTypeID,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQueryInfo/';
    this.dataService.setMethodName = 'GetRevaluationDashboardData?StudentID='+ StudentID+'&CoursePartID='+CoursePartID +'&ResultQueryTypeID='+ResultQueryTypeID+'&ExamInstanceID='+ExamInstanceID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public GetStudentPhotoCopyApplicationReport(StudentID,ApplicationNO,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQueryReport/';
    this.dataService.setMethodName = 'GetStudentPhotoCopyApplicationReport?StudentID='+ StudentID+'&ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }
  public GetStudentVerificationApplicationReport(StudentID,ApplicationNO,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQueryReport/';
    this.dataService.setMethodName = 'GetStudentVerificationApplicationReport?StudentID='+ StudentID+'&ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }
  public GetStudentRevaluationApplicationReport(StudentID,ApplicationNO,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQueryReport/';
    this.dataService.setMethodName = 'GetStudentRevaluationApplicationReport?StudentID='+ StudentID+'&ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }
  public GetStudentReVerificationApplicationReport(StudentID,ApplicationNO,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQueryReport/';
    this.dataService.setMethodName = 'GetStudentReVerificationApplicationReport?StudentID='+ StudentID+'&ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }
  public CheckPhotocopyData(StudentID,CoursePartID,ResultQueryTypeID,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQueryInfo/';
    this.dataService.setMethodName = 'CheckPhotocopyData?StudentID='+ StudentID+'&CoursePartID='+CoursePartID +'&ResultQueryTypeID='+ResultQueryTypeID+'&ExamInstanceID='+ExamInstanceID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public CancelResultQueryApplication(ApplicationNO,ExamInstanceID,UpdatedLoginID) {
    this.dataService.setControllerName = '/ResultQuerySubject/';
    this.dataService.setMethodName = 'CancelResultQueryApplication?ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID+'&UpdatedLoginID='+UpdatedLoginID; // setting method name from API controller.
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public UpdatePhotocopyDownloadDate(ApplicationNO,ExamInstanceID,UpdatedLoginID,SubjectID) {
    this.dataService.setControllerName = '/ResultQuerySubject/';
    this.dataService.setMethodName = 'UpdatePhotocopyDownloadDate?ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID+'&UpdatedLoginID='+UpdatedLoginID+'&SubjectID='+SubjectID; // setting method name from API controller.
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public GetResultQuerySubjectDataByStudentID(StudentID,ResultQueryTypeID,ExamInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/ResultQuerySubject/';
    this.dataService.setMethodName = 'GetResultQuerySubjectDataByStudentID?StudentID='+ StudentID+'&ResultQueryTypeID='+ResultQueryTypeID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public GetResultQueryPaymentReceipt(ApplicationNO,ResultQueryTypeID,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQueryReport/';
    this.dataService.setMethodName = 'GetResultQueryPaymentReceipt?ApplicationNO='+ApplicationNO+'&ResultQueryTypeID='+ResultQueryTypeID+'&ExamInstanceID='+ExamInstanceID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public GetResultQueryByCode(ResultQueryCode) {debugger
    this.dataService.setControllerName = '/ResultQuerySubject/';
    this.dataService.setMethodName = 'GetResultQueryByCode?ResultQueryCode='+ ResultQueryCode;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }

  public GetAppliedSubjectCount(StudentID,CoursePartID,ResultQueryTypeID,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/ResultQuerySubject/';
    this.dataService.setMethodName = 'GetAppliedSubjectCount?StudentID='+ StudentID+'&CoursePartID='+CoursePartID +'&ResultQueryTypeID='+ResultQueryTypeID+'&ExamInstanceID='+ExamInstanceID;
    return this.dataService.getAll<ResultQueryInfo[]>()
  }
}
